export default "__VITE_ASSET__BTAWByJW__"